import React, { Fragment } from 'react';
import { ViewUser } from "./buttons/ViewUser";
import { DeleteUser } from "./buttons/DeleteUser";

const TableRowComponent = ({ user, index, actionCallback }) => {
  return (
    user ?
      <tr>
        <td>{user.first_name}</td>
        <td>{user.last_name}</td>
        <td>{user.email}</td>
        <td className="w-10">
          <Fragment>
            <ViewUser
              user={user}
              index={index}
            />
            <DeleteUser
              user={user}
              index={index}
              showIcon={true}
              actionCallback={actionCallback}
            />
          </Fragment>
        </td>
      </tr>
      : null
  )
}

export { TableRowComponent };
